function toArray(val) {
  return val ? Array.isArray(val) ? val : [val] : [];
}
export default function useAction(action, showAction, hideAction) {
  var mergedShowAction = toArray(showAction !== null && showAction !== void 0 ? showAction : action);
  var mergedHideAction = toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
  return [new Set(mergedShowAction), new Set(mergedHideAction)];
}